export default {
    disclaimer: {
        label_default: "Reconheço e concordo que os artigos que estou a encomendar/receber são propriedade da DXC e serão utilizados para atividades relacionadas com o trabalho da DXC. Além disso, se o endereço fornecido estiver incorreto ou não confirmado e o meu pedido não for entregue, a DXC incorrerá em taxas de reposição de stock.",
        errors: {
            required: "Clique em \"Reconhecer declaração\" para fazer o pedido"
        }
    },
    preferred_delivery_date: {
        "Preferred Delivery Date": "Data de entrega preferida"
    },
    order_note: {
        label: "Nota do pedido",
        placeholder: "Nota para o aprovador deste pedido",
        errors: {
            required: "Nota de encomenda é necessária"
        }
    },
    send_emails_to_oobo_orderer: {
        "OOBO": "Notifique-me sobre atualizações sobre este pedido"
    },
    info: {
        label: "Observação: Para garantir a entrega dos seus itens, insira os dados completos do seu endereço, incluindo quaisquer instruções especiais. Verifique se o PIN e o número de telefone estão corretos e completos antes de enviar o pedido. Após o envio, os dados não poderão ser alterados e os pedidos não poderão ser cancelados."
    },
    info_EGY: {
        label: "A entrega não está disponível em áreas rurais. Se o seu endereço for fora de uma área metropolitana, seu pedido será enviado para o escritório local DXC. Você será responsável por retirar seu pedido no escritório assim que ele chegar. Você será avisado quando seu pedido estiver pronto para retirada. Se, por algum motivo, você não puder retirar seu pedido no escritório DXC, envie um ticket de suporte antes de enviar seu pedido."
    },
    shipping_next_quarter_message: {
        label: "Os pedidos podem sofrer atrasos durante o processamento do final do trimestre. Seu pedido foi recebido e será processado o mais breve possível."
    }
}